import currency from 'currency.js'
import moment from 'moment'
import { Address } from '../types'

class Utils {
	/**
	 * @name medlogix
	 * @param image
	 */

	/**
	 * @name toJSON
	 * @param object
	 */
	toJSON(object: any) {
		let json
		try {
			json = JSON.parse(JSON.stringify(object))
		} catch (e) {
			json = null
		}
		return json
	}

	/**
	 * @name randomString
	 * @param stringLength
	 */
	randomString(stringLength: number) {
		let text = ''
		let possible = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789"'
		for (let i = 0; i < stringLength; i++)
			text += possible.charAt(Math.floor(Math.random() * possible.length))
		return text
	}

	exportToCsv(filename: string, rows: any[], headerOnly: boolean = false) {
		// @ts-ignore
		const replacer = (key: any, value: any) => (value === null ? '' : value) // specify how you want to handle null values here
		const header = Object.keys(rows[0])
		let csv
		if (headerOnly) {
			csv = [
				header.join(','), // header row first
			].join('\r\n')
		} else {
			csv = [
				header.join(','), // header row first
				...rows.map((row: any) =>
					header.map((fieldName) => JSON.stringify(row[fieldName], replacer)).join(',')
				),
			].join('\r\n')
		}

		const blob = new Blob([csv], { type: 'text/csv;charset=utf-8;' })
		const link = document.createElement('a')
		if (link.download !== undefined) {
			const url = URL.createObjectURL(blob)
			link.setAttribute('href', url)
			link.setAttribute('download', filename)
			link.style.visibility = 'hidden'
			document.body.appendChild(link)
			link.click()
			document.body.removeChild(link)
		}
	}

	/**
	 * @param ms
	 */
	async sleep(ms: number) {
		return new Promise((resolve) => setTimeout(resolve, ms))
	}

	/**
	 * @param date
	 * @param format
	 */
	dateFormat(date: any, format: string) {
		date = date?.hasOwnProperty('iso') ? date?.iso : date ? date : new Date()
		const style =
			format === 'full'
				? 'ddd, MMM Do YYYY HH:mm:ss'
				: format === 'long'
					? 'ddd, MMM Do YYYY'
					: format === 'short'
						? 'MMM Do, YYYY'
						: 'ddd, MMM Do YYYY'
		return moment(date).format(style)
	}

	/**
	 * @name isTrue
	 * @param value
	 */
	isTrue(value: any) {
		return !(
			value === '[object Object]' ||
			value === 'undefined' ||
			value === undefined ||
			value === null ||
			value === 'null' ||
			value === 'NaN' ||
			Number.isNaN(value) ||
			value === ''
		)
	}

	/**
	 * @name maskPrice
	 * @param number
	 */
	maskPrice(number: any) {
		number = number ? number : 0
		number = currency(number || 0)
		number += ''
		let price
		let x = number.split('.')
		let x1 = x[0]
		let x2 = x.length > 1 ? '.' + x[1] : ''
		let rgx = /(\d+)(\d{3})/
		while (rgx.test(x1)) {
			x1 = x1.replace(rgx, '$1' + ',' + '$2')
		}
		price = x1 + x2
		return price === '0' ? '0.00' : price
	}

	/**
	 * @name barcodeStringSrv
	 * @param stringLength
	 */
	barcodeStringSrv(stringLength: number) {
		let text = ''
		let possible = '012345678901234567890123456789012345678901234567890123456789'
		for (let i = 0; i < stringLength; i++)
			text += possible.charAt(Math.floor(Math.random() * possible.length))
		return text.toUpperCase()
	}

	/**
	 * @name bytes
	 * @param bytes
	 * @param precision
	 */
	bytes(bytes: number, precision: number | undefined) {
		if (isNaN(parseFloat(String(bytes))) || !isFinite(bytes)) return '-'
		if (typeof precision === 'undefined' || !precision) precision = 1
		let units = ['bytes', 'kB', 'MB', 'GB', 'TB', 'PB'],
			number = Math.floor(Math.log(bytes) / Math.log(1024))
		return (bytes / Math.pow(1024, Math.floor(number))).toFixed(precision) + ' ' + units[number]
	}

	/**
	 * @name parsePrice
	 * @param number
	 */
	parsePrice(number: any) {
		let raw = number
		try {
			number = number.toString()
		} catch (e) {
			number = number
		}

		let regex = /[^0-9\.\|]+/
		//let number = 'R 1,500#_SR,xc!#±*/77.s25'
		if (number) {
			number = parseFloat(number.split(regex).join(''))
			return number
		}
		return raw
	}

	/**
	 * @name numberFormatter
	 * @param number
	 */
	numberFormatter(number: number, digits: number = 1) {
		try {
			const lookup = [
				{ value: 1, symbol: '' },
				{ value: 1e3, symbol: 'k' },
				{ value: 1e6, symbol: 'M' },
				{ value: 1e9, symbol: 'G' },
				{ value: 1e12, symbol: 'T' },
				{ value: 1e15, symbol: 'P' },
				{ value: 1e18, symbol: 'E' },
			]
			const rx = /\.0+$|(\.[0-9]*[1-9])0+$/
			let item = lookup
				.slice()
				.reverse()
				.find(function (item) {
					return number >= item.value
				})
			return item
				? (number / item.value).toFixed(digits).replace(rx, '$1') + item.symbol
				: '0'
		} catch (error) {
			return number.toString()
		}
	}

	getCustomer(doc: any) {
		try {
			return doc?.patient || doc?.recepient || doc?.customer || doc?.contact
		} catch {}
	}

	getPractitioner(doc: any) {
		try {
			return doc?.bearer
		} catch {}
	}

	getOrganization(doc: any) {
		try {
			return doc?.account
		} catch {}
	}

	getSignature(doc: any) {
		try {
			return doc?.bearer?.profileImageSignature?.files?.url
		} catch {
			return null
		}
	}

	getOrganizationLogo(doc: any) {
		try {
			return doc?.account?.accountImage?.files?.url
		} catch {
			return null
		}
	}

	formatAddress(_addressObject: Address): string {
		try {
			const { address, addressOptional, city, postCode, country } = _addressObject

			const lines: string[] = []

			const safePush = (value?: string) => {
				const trimmed = value?.trim()
				if (trimmed) {
					lines.push(trimmed)
				}
			}

			safePush(address)

			safePush(addressOptional)

			const cityLine = [city, postCode]
				.map((s) => s?.trim())
				.filter(Boolean)
				.join(' ')

			safePush(cityLine)

			safePush(country)

			return lines.join('\n')
		} catch (error) {
			return ''
		}
	}
}

const utils = new Utils()
export default utils
